<template>
  <div class="page">
    <div class="header-menu">
      <div class="navBar">
        <div @click="back" class="back">
          <img src="/static/img/left2.png" />
        </div>
        <div>{{ $t("system_user_businessregister_qiyeyonghuzhuce") }}</div>
        <div></div>
      </div>
    </div>
    <div class="page-content">
      <div class="businessRegister">
        <div class="businessRegister-title">{{ $t("system_user_businessregister_qiyeyonghuzhuce") }}</div>
        <div class="businessRegister-wrapper" v-if="Steps == 1">
          <div style="padding:0 0.798rem 0.532rem 0.798rem;text-align: center;font-size: 0.372rem;color: #666">
            <div>{{ $t("system_user_businessregister_ruguigongsiyishilichengshanglvqianyueqiye") }}</div>
            <div>{{ $t("system_user_businessregister_qinglianxinindechalvfuzerenhuoquzhanghaowuzhongfuzhuce") }}</div>
          </div>
          <div class="businessRegister-item">
            <div>
              <input v-model="model.RoleName" :placeholder="$t('system_user_businessregister_qingshuruninqiyemingcheng')" type="text" />
            </div>
            <div>{{ $t("system_user_businessregister_qiyemingcheng") }}</div>
          </div>
          <div class="border_bottom"></div>
          <div class="businessRegister-item">
            <div>
              <input v-model="model.UserAccount.UserAct" :placeholder="$t('system_user_businessregister_shoujihaohuoyouxiangzhuce')" />
            </div>
            <div>{{ $t("system_user_businessregister_shoujihao") }}</div>
          </div>
          <div class="border_bottom"></div>
          <div class="businessRegister-item">
            <div style="width: 1.5rem; vertical-align: middle;">
              <input v-model="model.UserAccount.validCode" :placeholder="$t('system_user_businessregister_qingshuruyanzhengma')" />
            </div>
            <div>{{ $t("system_user_businessregister_yanzhengma") }}</div>
            <div style="width:2.261rem;">
              <img :src="checkImageUrl" style="width:100%;vertical-align: middle" @click="ReloadImage" />
            </div>
          </div>
          <!-- <div class="businessRegister-item">
            <div>
              <input v-model="model.RoleIntro" :placeholder="$t('system_user_businessregister_qingshuruguiqiyesuoshuhangye')" type="text" />
            </div>
            <div>{{$t('system_user_businessregister_qiyehangye')}}</div>
          </div>
          <div class="border_bottom"></div> -->
          <!-- <div class="businessRegister-item">
            <div>
              <input class="softKeyboardHide" @click="countryDialog" v-if="selectedText.length>0"
                v-model="selectedText[0].label" ::placeholder="$t('system_user_businessregister_qingshuruguiqiyediqu')" type="text">
            </div>
            <div>{{$t('system_user_businessregister_qiyediqu')}}</div>
          </div>
          <div class="border_bottom"></div> -->
          <!-- <div class="businessRegister-item">
            <div>
              <input v-model="model.ContactName" :placeholder="$t('system_user_businessregister_qingtianxielianxirenxingming')" type="text" />
            </div>
            <div>{{$t('system_user_businessregister_lianxiren')}}</div>
          </div>
          <div class="border_bottom"></div> -->
        </div>
        <div class="businessRegister-wrapper" v-if="Steps == 2">
          <!-- <div class="businessRegister-item">
            <div>
              <input v-model="model.UserAccount.UserAct" :placeholder="$t('system_user_businessregister_shoujihaohuoyouxiangzhuce')" />
            </div>
            <div>{{$t('system_user_businessregister_zhucezhanghao')}}</div>
          </div>
          <div class="border_bottom"></div>
          <div class="businessRegister-item">
            <div>
              <input v-model="model.UserAccount.UserPwd" :placeholder="$t('system_user_businessregister_qingshezhidenglumima')" type="password" />
            </div>
            <div>{{$t('system_user_businessregister_denglumima')}}</div>
          </div>
          <div class="border_bottom"></div>
          <div class="businessRegister-item">
            <div>
              <input v-model="model.UserAccount.ConfirmPwd" :placeholder="$t('system_user_businessregister_zaicishurumima')" type="password">
            </div>
            <div>{{$t('system_user_businessregister_querenmima')}}</div>
          </div>
          <div class="border_bottom"></div> -->
          <div class="businessRegister-item">
            <div class="VerificationCode" style="width: 1.5rem; vertical-align: middle;">
              <input v-model="model.UserAccount.mobileCode" :placeholder="$t('system_user_businessregister_qingshuruyanzhengma')" />
            </div>
            <div>{{ $t("system_user_businessregister_yanzhengma") }}</div>
            <div style="width:2.261rem;">
              <span class="sendCode" v-if="judgeCode" @click="sendCode">{{ textCode }}</span>
              <span class="sendCode" v-else>{{ textCode }}</span>
            </div>
          </div>
          <div class="border_bottom"></div>
          <div style="margin-top:0.399rem;">
            <input type="checkbox" id="protocol" style="vertical-align: middle" v-model="isAgree" />
            <label style="vertical-align: middle;" for="protocol">
              <a>{{ $t("system_user_businessregister_tongyi") }}</a>
              <a style="color: #12a3ff"
                >《{{ $t("system.Name") }}<span>{{ $t("system_user_businessregister_fuwuxieyi") }}</span
                >》</a
              >
            </label>
          </div>
        </div>
        <div v-if="Steps == 1" class="businessRegister-btn" @click="AddStep">
          <span>{{ $t("system_user_businessregister_xiayibuyanzheng") }}</span>
        </div>
        <div v-if="Steps == 2" class="businessRegister-btn" @click="businessRegister">
          <span>{{ $t("system_user_businessregister_wancheng") }}</span>
        </div>
        <div class="businessRegister-remark">
          <p>{{ $t("system_user_businessregister_ruzhucechuxianwenti") }}</p>
          <p>
            {{ $t("system_user_businessregister_qingboda") }}<a style="color:#12a3ff">{{ $t("system.servicePhone") }}</a
            >{{ $t("system_user_businessregister_lianxikefuweinijieda") }}
          </p>
        </div>
        <privacy :prefix="$t('system_user_businessregister_zhuce')"></privacy>
      </div>
    </div>
    <picker @select="handleSelect(0, arguments)" ref="picker" :cancelTxt="cancelTxt" :confirmTxt="confirmTxt"></picker>
  </div>
</template>
<style scoped>
  .navBar {
    color: #fff;
    font-size: 0.425rem;
    height: 1.489rem;
    line-height: 1.489rem;
    padding: 0 0.266rem;
    position: relative;
    background-color: #12a3ff;
  }

  .navBar > div:nth-child(2) {
    text-align: center;
    width: 5.32rem;
    margin: 0 auto;
  }

  .navBar > div:last-child {
    color: #fff;
    position: absolute;
    right: 0.266rem;
    top: 0;
    width: 2.66rem;
    text-align: right;
  }

  .back {
    width: 1.33rem;
    position: absolute;
    bottom: 0;
  }

  .navBar img {
    width: 0.372rem;
    margin-bottom: -0.106rem;
  }

  .page-content {
    background-color: #fff;
  }

  .businessRegister-wrapper {
    padding: 0 0.399rem;
  }

  .businessRegister-title {
    color: #2975e6;
    font-weight: bold;
    font-size: 0.31rem;
    padding: 0.93rem 0 0.798rem 0;
    text-align: center;
  }

  .businessRegister-item {
    position: relative;
    font-size: 0.372rem;
    /* border-bottom: 0.01rem solid #e3e3e3;
    box-sizing: border-box; */
  }

  .businessRegister-item > div {
    height: 1.33rem;
    line-height: 1.33rem;
    font-size: 0.425rem;
    color: #323232;
  }

  .businessRegister-item > div:first-child {
    margin-left: 2.926rem;
  }

  .businessRegister-item > div:nth-child(2) {
    position: absolute;
    top: 0;
    left: 0;
    width: 2.66rem;
    padding-left: 0.266rem;
  }

  .businessRegister-item .VerificationCode {
    margin-right: 1.729rem;
  }

  .businessRegister-item > div:nth-child(3) {
    position: absolute;
    top: 0;
    right: 0;
    width: 1.729rem;
  }

  .businessRegister-item > div input {
    width: 100%;
    height: 100%;
    border: none;
  }

  .businessRegister-btn {
    width: 3.35rem;
    text-align: center;
    background-color: #2975e6;
    color: #fff;
    font-size: 0.452rem;
    height: 1.197rem;
    line-height: 1.197rem;
    margin: 0.798rem auto;
    border-radius: 0.106rem;
  }

  .businessRegister-remark {
    text-align: center;
    font-size: 0.372rem;
    color: #999999;
    margin-bottom: 40px;
  }

  .businessRegister-remark p {
    margin: 0;
    padding: 0 0 0.212rem 0;
  }

  .businessRegister .sendCode {
    background-color: #ff9519;
    height: 0.798rem;
    line-height: 0.798rem;
    color: #fff;
    display: inline-block;
    font-size: 0.345rem;
    width: 100%;
    text-align: center;
    border-radius: 0.106rem;
  }
</style>
<script>
  import picker from "../modules/picker.vue";
  import navBar from "../modules/navBar.vue";
  import privacy from "./modules/privacyPolicy.vue";
  import baseService from "@/service/baseService";
  import { RoleType, ZoneType } from "@/model/Base";
  export default {
    data() {
      return {
        objSave: {
          centerTitle: "system.Register",
        },
        model: {
          RoleName: "",
          RootID: "",
          RoleType: "",
          ContactName: "",
          RoleIntro: "",
          Remark: "",
          UserAccount: {
            UserID: "",
            UserAct: "",
            UserPwd: "******",
            ConfirmPwd: "******",
            validCode: "",
            mobileCode: "",
          },
          ContactInfo: {
            CityID: "1321",
            ContactPeople: "",
          },
        },
        selectedIndex: [],
        cancelTxt: "share.cancelTxt",
        confirmTxt: "share.confirmTxt",
        selectedText: [],
        CountryLists: [],
        Steps: 1,
        totalSteps: 2,
        textCode: this.$root.$t("system.SendDynamicCode"),
        judgeCode: true,
        setInterval: null,
        checkImageUrl: "",
        isAgree: true,
        ReferInfo: {},
      };
    },
    computed: {
      ReferID() {
        return this.$route.query.ReferID;
      },
    },
    mounted() {
      let __self = this;
      __self.getCitys();
      $(window).bind("popstate", function(e) {
        if (__self.Steps > 1) {
          __self.Steps--;
        }
      });
      __self.ReloadImage();
      if (__self.ReferID) {
        __self.getReferInfo();
      }
    },
    methods: {
      getReferInfo() {
        let __self = this;
        UserService.getReferInfo(__self.ReferID).then(json => {
          if (json.isSucc) {
            __self.ReferInfo = json.result;
          }
        });
      },
      back() {
        let __self = this;
        history.back();
      },
      ReloadImage() {
        let __self = this;
        __self.checkImageUrl = `/api/side/common/ValidCode?${Math.random()}`;
        // __self.checkImageUrl = __self.$api.side.getValidImageUrl();
      },
      getCitys() {
        let __self = this;
        let data = {
          PageSize: 100000,
          CountryID: 151,
          ZoneType: ZoneType.Province + "",
          Props: "ZoneCode,ZoneName,ZoneID",
        };
        baseService.getZoneList(data).then(function(json) {
          if (json.isSucc) {
            __self.CountryLists = json.result.entities;
            __self.CountryLists.forEach((o, index) => {
              o.label = o.ZoneName;
              if (o.ZoneID == __self.model.ContactInfo.CityID) {
                __self.selectedText.push(o);
                __self.$refs.picker.setSelectedIndex([index]);
              }
              __self.$refs.picker.setData([__self.CountryLists]);
            });
          }
        });
      },
      countryDialog() {
        this.$refs.picker.show();
      },
      AddStep() {
        let __self = this;
        let RegExp = $utils.RegExp;
        if (__self.model.RoleName == "") {
          return $utils.fail(this.$root.$t("system_user_businessregister_gongsimingchengbunengkong"), "fail");
        }
        if (__self.model.UserAccount.UserAct == "") {
          return $utils.fail(__self.$t("RegExp.AccountReg.isEmpty"), "fail");
        }
        if (!(RegExp.MobileReg.test(__self.model.UserAccount.UserAct) || RegExp.EmailReg.test(__self.model.UserAccount.UserAct))) {
          return $utils.fail(__self.$t("RegExp.AccountReg.isFormat"), "fail");
        }
        if (__self.model.UserAccount.validCode == "") {
          return $utils.fail(__self.$t("RegExp.VerificationCodeReg.isEmpty"), "fail");
        }
        UserService.AccountExists({
          UserAct: __self.model.UserAccount.UserAct,
        }).then(json => {
          if (json.isSucc) {
            if (!json.result) {
              let $time = 60;
              UserService.sendValidCode(__self.model.UserAccount).then(function(json) {
                if (json.isSucc) {
                  this.$root.$toast.success(json.data.message, "succ");
                  __self.judgeCode = false;
                  __self.setInterval = setInterval(run, 1000);

                  function run() {
                    __self.textCode = __self.$t("system.Sent") + --$time;
                    if ($time <= 0) {
                      clearInterval(__self.setInterval);
                      __self.textCode = __self.$t("system.SendDynamicCode");
                      __self.judgeCode = true;
                    }
                  }
                  __self.Steps++;
                  history.pushState({}, __self.Steps, location.href);
                }
              });
            } else {
              return $utils.fail(this.$root.$t("system_user_businessregister_dangqianshoujihaoyibeizhuce"), "fail");
            }
          }
        });
      },
      businessRegister() {
        let __self = this;
        if (__self.Steps == __self.totalSteps) {
          let RegExp = $utils.RegExp;
          // if (__self.model.UserAccount.UserAct == "") {
          //   return $utils.fail(__self.$t('RegExp.AccountReg.isEmpty'), 'fail');
          // }
          // if (!(RegExp.MobileReg.test(__self.model.UserAccount.UserAct) || RegExp.EmailReg.test(__self.model.UserAccount.UserAct))) {
          //   return $utils.fail(__self.$t('RegExp.AccountReg.isFormat'), 'fail');
          // }
          // if (__self.model.UserAccount.UserPwd == "") {
          //   return $utils.fail(__self.$t('RegExp.PwdReg.isEmpty'), 'fail');
          // }
          // // if (!RegExp.PwdReg.test(__self.model.UserAccount.UserPwd)) {
          // //   return $utils.fail(__self.$t('RegExp.PwdReg.isEmpty'), 'fail');
          // // }
          // if (__self.model.UserAccount.ConfirmPwd == "") {
          //   return $utils.fail(__self.$t('RegExp.ConfigPwd.isEmpty'), 'fail');
          // }
          // if (!RegExp.PwdReg.test(__self.model.UserAccount.ConfirmPwd)) {
          //   return $utils.fail(__self.$t('二次密码格式不正确'), 'fail');
          // }
          // if (__self.model.UserAccount.ConfirmPwd != __self.model.UserAccount.UserPwd) {
          //   return $utils.fail(__self.$t('密码不一致'), 'fail');
          // }
          // if (__self.model.UserAccount.validCode == "") {
          //   return $utils.fail(__self.$t('RegExp.VerificationCodeReg.isEmpty'), 'fail');
          // }
          if (__self.model.UserAccount.mobileCode == "") {
            return $utils.fail(__self.$t("RegExp.DynamicCodeReg.isEmpty"), "fail");
          }
          if (!__self.isAgree) {
            return $utils.fail(__self.$t("RegExp.ProtocolReg.isFlag"), "fail");
          }
          // if (__self.currentView == 'userRegister') {
          //   __self.model.RoleType = __self.RoleTypeTypes.User
          //   __self.model.RoleName = __self.model.UserAccount.UserAct
          // } else {
          // }
          __self.model.RoleType = RoleType.Company;
          // __self.model.ContactInfo.CityID = __self.model.CityID;
          __self.model.ContactInfo.ContactPeople = __self.model.ContactName;
          if (__self.ReferID) {
            data.RoleName = __self.ReferInfo.RoleName;
            data.RoleNick = __self.ReferInfo.RoleNick;
            data.RoleIcon = __self.ReferInfo.RoleIcon;
            data.RoleGenre = __self.ReferInfo.RoleGenre;
            data.BirthDate = __self.ReferInfo.BirthDate;
          }
          UserService.register(__self.model).then(json => {
            if (json.isSucc) {
              __self.$toast.success(__self.$t("share.succ.RegisteredSucc"));
              let data = {
                UserAct: __self.model.UserAccount.UserAct,
                IsRemember: true,
                DeviceInfo: "App",
                ValidCode: "",
                LoginMode: 10230,
                UserPwd: __self.model.UserAccount.UserPwd,
              };
              __self.$store.dispatch("login", data).then(function(response) {
                if (response.isSucc) {
                  __self.$toast.success(__self.$t("share.succ.LoginSucc"));
                  let redirect = __self.$route.query.redirect;
                  redirect = redirect && redirect.indexOf("redirect") == -1 ? redirect : "/";
                  if (redirect && redirect.indexOf("/auth/bind") > 0) {
                    location.href = redirect;
                  } else {
                    __self.$router.push({
                      path: "/",
                    });
                  }
                }
              });
            }
          });
        }
      },
      sendCode() {
        let __self = this;
        if (__self.model.UserAccount.UserAct == "") {
          return $utils.fail(__self.$t("share.fail.RegisterPhone"), "fail");
        }
        if (__self.model.UserAccount.validCode == "") {
          return $utils.fail(__self.$t("share.fail.VerificationCode"), "fail");
        }
        if (__self.judgeCode) {
          let $time = 60;
          UserService.sendValidCode(__self.model.UserAccount).then(function(json) {
            if (json.isSucc) {
              this.$root.$toast.success(json.data.message, "succ");
              __self.judgeCode = false;
              __self.setInterval = setInterval(run, 1000);

              function run() {
                __self.textCode = __self.$t("system.Sent") + --$time;
                if ($time <= 0) {
                  clearInterval(__self.setInterval);
                  __self.textCode = __self.$t("system.SendDynamicCode");
                  __self.judgeCode = true;
                }
              }
            }
          });
        }
      },
      handleSelect(index, args) {
        let __self = this;
        __self.selectedText.splice(index, 1, args[2][0]);
        __self.model.ContactInfo.CityID = __self.selectedText[0].ZoneID;
      },
    },
    components: {
      navBar,
      picker,
      privacy,
    },
  };
</script>
